<template>
  <UtilityText class="dbc-form-privacy-statement" :text="privacyStatement" />
</template>

<script setup lang="ts">
const { t, locale } = useI18n()
const client = useRuntimeConfig().public.client
const clientBaseUrlMap = useRuntimeConfig().public
  .clientBaseUrlMapping as ClientBaseUrlMapping

const privacyStatement = ref(t('dbc-cancel-contract-privacy-statement'))
const privacyPagePath = getPagePath['privacy']![locale.value]
privacyStatement.value = privacyStatement.value!.replace(
  `(${privacyPagePath})`,
  `(${clientBaseUrlMap[client]}${privacyPagePath})`
)
</script>
